import { Outlet } from 'react-router-dom'

import { Features } from 'generated/featureDefinitions'

import { GoogleMapsProvider } from 'modules/core/components/GoogleMaps/GoogleMapsProvider'
import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import hasFeature from 'modules/core/lib/hasFeature'

import WorkplaceDetailsComponent from 'modules/locations/pages/Locations/WorkplaceDetails'

const AuthorizedWorkplaceDetailsPage = () => {
  const { featureAvailability: hasGeofencingFeatureAvailability } = useFeatureAvailability(
    Features.time_tracking_geofencing_alerts
  )

  const hasGeofencingFeature = hasGeofencingFeatureAvailability.available
  const hasGeoBlockingFeature = hasFeature('dev_time_tracking_geofencing_block')

  return (
    <GoogleMapsProvider mapsEnabled={hasGeofencingFeature || hasGeoBlockingFeature}>
      <WorkplaceDetailsComponent>
        <Outlet />
      </WorkplaceDetailsComponent>
    </GoogleMapsProvider>
  )
}

export default AuthorizedWorkplaceDetailsPage
